import angular from 'angular';
import ngRoute from 'angular-route';

import routes from './advisory.routes';
import auditTrail from './auditTrail';
import bcp from './bcp';
// import committeeManager from './committeeManager';
import ecat from './eCAT';
import enterpriseModeling from './enterpriseModeling';
import policyManagement from './policyManagement';
import vendorManagement from './vendorManagement';
import oversight from './oversight';
import pra from './pra';

export default angular.module('app.components.advisory', [
  ngRoute,
  auditTrail,
  bcp,
  // committeeManager,
  ecat,
  enterpriseModeling,
  policyManagement,
  vendorManagement,
  oversight,
  pra
])
  .config(routes)
  .name;

console.log('app.components.advisory created');
